module.exports = __webpack_public_path__ + "static/media/logo-stacked.e520836e.svg";